import Column from './column';

export default Column;
